import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Stack,
  Typography,
  useTheme,
  alpha,
  DialogTitle,
} from "@mui/material";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ConfirmationDialog = ({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onClose,
  confirmColor = "primary",
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3, // 更大的圆角，更现代
          boxShadow: 24,
        },
      }}
    >
      {/* 顶部 Header：更加轻量化的布局 */}
      <DialogTitle
        sx={{
          p: 3,
          pb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Stack direction='row' spacing={2} alignItems='center'>
          {/* 图标区域：使用主题色生成的柔和背景 */}
          <Box
            sx={{
              p: 1.2,
              // 如果主题支持，优先使用 channel 变量，否则使用 alpha 降级
              bgcolor: alpha(theme.palette[confirmColor].main, 0.1),
              color: `${confirmColor}.main`,
              borderRadius: "50%", // 圆形背景比圆角矩形更柔和
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* 根据 confirmColor 动态切换图标语义会更好，这里暂用原图标 */}
            <ConfirmationNumberIcon fontSize='small' />
          </Box>
          <Typography variant='h6' fontWeight={700} component='div'>
            {title}
          </Typography>
        </Stack>
      </DialogTitle>

      {/* 内容区域：增加描述的柔和度 */}
      <DialogContent sx={{ px: 3, pt: 1, pb: 3 }}>
        <DialogContentText
          sx={{ color: "text.secondary", fontSize: "0.95rem", lineHeight: 1.6 }}
        >
          {description}
        </DialogContentText>
      </DialogContent>

      {/* 底部按钮：去掉了独立的背景和边框，与整体融合 */}
      <DialogActions
        sx={{ px: 3, py: 2.5, pt: 0, justifyContent: "flex-end", gap: 1.5 }}
      >
        <Button
          onClick={onClose}
          variant='outlined'
          color='inherit' // 取消按钮通常用灰色或继承色，降低视觉干扰
          sx={{ borderRadius: 2, px: 2.5 }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          variant='contained'
          color={confirmColor}
          disableElevation // 扁平化的按钮在现代弹窗中更常见
          startIcon={<CheckCircleIcon />} // 增加图标增强警示感
          sx={{ borderRadius: 2, px: 2.5, boxShadow: 1 }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
